module.exports = {"className":"CardType","classNameLabel":"Card Types","limit":5,"columns":[{"columnName":"objectId","type":"string"},{"columnName":"name","type":"string"},{"columnName":"createdAt","type":"Date"},{"columnName":"updatedAt","type":"Date"}]}


//////////////////
// WEBPACK FOOTER
// ./components/schema/CardType.json
// module id = 1154
// module chunks = 0